module.exports = __webpack_public_path__ + "static/img/cqlogo.baff0e19.png";